import React, { useEffect, useState } from "react";
import "./DivisionName.css";
import close from "../../../../../../../../assets/close.svg";
import axiosApi from "../../../../../../../../core/interceptor/interceptor";
import { config } from "../../../../../../../../config";

export default function LocationModal(props) {
  const [division, setDivision] = useState([]);

  const handleChange = (e, k) => {
    const temp = [...division];
    temp[k].name = e.target.value;
    setDivision(temp);
  };

  useEffect(() => {
    const division = [...props.selectedData];
    setDivision(division);
  }, [props.selectedData]);

  const closeModal = (data = null) => {
    if (props.closeModal) {
      props.closeModal(data);
    }
  };

  const handleSubmit = () => {
    axiosApi
      .put(`${config.apiUrl}/leagues/bulk/update-league-division`, { division })
      .then((res) => {
        closeModal();
      });
  };

  return (
    <>
      <div className="modal TimeModal">
        <div className="modal-header">
          <h2>Edit Division Name</h2>
          <span className="close" onClick={closeModal}>
            <img src={close} alt="close-icon" />
          </span>
        </div>
        <div className={`modal-body  modal-division-name`}>
          <form>
            {division &&
              division.length > 0 &&
              division.map((val, key) => {
                return (
                  <div className="form-control" key={key}>
                    <input
                      type="text"
                      value={val.name}
                      onChange={(e) => handleChange(e, key)}
                    />
                  </div>
                );
              })}
          </form>
        </div>
        <div className="modal-footer d-flex">
          <button className="cancel-btn" onClick={() => closeModal()}>
            Cancel
          </button>
          <button
            type="submit"
            onClick={() => {
              handleSubmit();
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    </>
  );
}
